import React from "react";
// Comps
import { IonPage } from "@ionic/react";
import Container from "components/common/Container/Container";
import Logo from "components/common/Logo/Logo";
import Form from "components/pages/Game/Join/Form/Form";
// Css
import classes from "./Join.module.scss";

const Join: React.FC = () => {
  return (
    <IonPage>
      <Container className={classes.container}>
        <Logo maxWidth="150px" />
        <h2 className={classes.title}>JOIN EXISTING GAME</h2>
        <p className={classes.desc}>enter your name and game's code below.</p>
        <Form />
      </Container>
    </IonPage>
  );
};

export default Join;
